<mat-grid-list cols="2" rowHeight="900px" >
  <mat-grid-tile>
    <mat-card class="myCard">

      @if (tarif==undefined) {
        <div>
          Der Pasura-Tarifserver ist zur Zeit nich verfügbar.
          <br>
            Die Verbindung zum BackEnd-Server konnte nicht erstellt werden!
            <br>
              Bitte konntaktieren Sie den Systemverantwortlichen.
              <br>
              </div>
            }

            <form  #form="ngForm" style="margin: 10px">


              <div class="TarifTitel">
                Haupt-Tarif
              </div>

              @if (tarif!=undefined) {
                <div >
                  <mat-button-toggle-group>
                    @for (tarif of tarife; track tarif) {
                      <mat-button-toggle  layout-align="end left"  value='{{tarif.TarifID}}'  selectable="true"
                        (change)="toggleTarif(tarif)"
                        [checked]="isSelTarif(tarif)">
                        {{tarif.MarketingName}} &nbsp;
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>
                </div>
              }

              <div class="TarifTitel">Sub-Tarif</div>

              @if (tarif!=undefined) {
                <div>
                  <mat-button-toggle-group >
                    @for (sub of  tarif.SubTarife ; track sub) {
                      <mat-button-toggle layout-align="end left"  value='{{tarif.TarifID}}'  selectable="true"
                        (change)="toggleSubTarif(sub)"
                        [checked]="isSelSubTarif(sub)">
                        {{sub.MarketingName}} &nbsp;
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>
                </div>
              }

              <div class="TarifTitel">Produkt</div>

              @if (tarif!=undefined) {
                <div>
                  <mat-button-toggle-group  >
                    @for (produkt of  tarif.Produkte ; track produkt) {
                      <mat-button-toggle layout-align="end left"  selectable="true"
                        (change)="toggleProdukt(produkt)"
                        [checked]="isSelProdukt(produkt)">
                        {{produkt.MarketingName}} &nbsp;
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>
                </div>
              }

              @if (tarif!=undefined && tarif.OptionenBK!=undefined && produkt.OptionenBK==true ) {
                <div>
                  <mat-button-toggle-group  >
                    @for (opt of tarif.OptionenBK; track opt) {
                      <mat-button-toggle layout-align="end left"  selectable="true"
                        value={{opt.OptionID}}
                        (change)="toggleOptionBK(opt)"
                        [checked]="isSelOptionBK(opt.OptionID)"
                        >
                        {{opt.OptionID}} &nbsp;
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>
                </div>
              }

              @if (tarif!=undefined && praemie.TarifID=='Pferd') {
                <div  (change)="getPraemie()">
                  @if (produkt!=undefined && produkt.SB) {
                    <div>
                      <div class="TarifTitel">
                        Selbsbehalt auf {{produkt.MarketingName}}
                      </div>
                      <div>
                        <mat-button-toggle-group >
                          @for (sb of selbstbehalt ; track sb) {
                            <mat-button-toggle layout-align="end left"
                              (change)="toggleSB(sb)"
                              [checked]="isSelSB(sb)" >
                              {{sb.Text}} &nbsp;
                            </mat-button-toggle>
                          }
                        </mat-button-toggle-group>
                      </div>
                    </div>
                  }
                  <div class="TarifTitel">
                    Optionen
                  </div>
                  <div >
                    <mat-button-toggle-group multiple >
                      @for (opt of tarif.Optionen; track opt) {
                        <mat-button-toggle layout-align="end left" selectable="true"
                          (change)="toggleOption(opt)"
                          value ={{opt.OptionID}}
                          [disabled] = "opt.OptionID=='Helikoptertransport' &&  isSelOption('Eco') && praemie.ProduktID!='Todesfall'"
                          [disabledInteractive]=false
                          [checked]="isSelOption(opt.OptionID)"
                          >
                          {{opt.MarketingName}} &nbsp;
                        </mat-button-toggle>
                      }
                    </mat-button-toggle-group>
                  </div>
                </div>
              }

              @if (tarif!=undefined && praemie.TarifID!='Rindvieh') 
              {
                <div class="abstandOben">
                  <mat-form-field class="example-full-width">
                    <mat-label>Flottenrabatt</mat-label>
                    <input matInput [(ngModel)]="praemie.FlottenRabattProz"  name="FlottenRabattProz"  type="number" size="2" step="1" >
                  </mat-form-field>

                  <mat-checkbox style="margin-left:20px"
                    name="FlottenRabattBehandlungskosten"
                    [checked]="praemie.FlottenRabattBehandlungskosten"
                    (change)="praemie.FlottenRabattBehandlungskosten=!praemie.FlottenRabattBehandlungskosten"
                    >
                    FlottenRabatt inkl. Behandlungskosten
                  </mat-checkbox>

                </div>
              }


              <div  class="abstandOben" style="float: left; width: 50%;" >
                <mat-form-field>
                  <mat-label>Geburtsdatum:</mat-label>
                  <input matInput [matDatepicker]="GebDat"  [(ngModel)]="praemie.GebDat"  name="GebDat"  (keyup)="checkGebdat($event)">
                  <mat-datepicker-toggle matSuffix [for]="GebDat"></mat-datepicker-toggle>
                  <mat-datepicker #GebDat></mat-datepicker>
                </mat-form-field>
              </div>

              <div>
                <mat-form-field>
                  <mat-label>Versicherungsbeginn:</mat-label>
                  <input matInput [matDatepicker]  [(ngModel)]="praemie.VBeginn"  name="VBeginn" >
                  <mat-datepicker-toggle matSuffix [for]="GebDat"></mat-datepicker-toggle>
                  <mat-datepicker #GebDat></mat-datepicker>
                </mat-form-field>
              </div>


              @if (tarif!=undefined && praemie.TarifID=='Rindvieh') {
                <div (change)="getPraemie()">
                  <div class="abstandUnten">
                    <mat-chip-list >
                      <mat-chip-option  layout-align="left"  selectable="true"
                        (click)="(praemie.Sex='W')"
                        [selected]="praemie.Sex=='W'">
                        weiblich &nbsp;
                      </mat-chip-option>
                      <mat-chip-option layout-align="left"    selectable="true"
                        (click)="(praemie.Sex='M')"
                        [selected]="praemie.Sex=='M'">
                        männlich &nbsp;
                      </mat-chip-option>
                    </mat-chip-list>
                  </div>
                </div>
              }



              <div>
                <mat-form-field class="example-full-width">
                  <mat-label>Versicherungssumme</mat-label>
                  <input matInput [(ngModel)]="praemie.VS"  name="VS"  type="number" size="7" step="100" >
                </mat-form-field>
              </div>
              @if (praemie.VS<=0) {
                <div > (Bei VS=0 wird mit maximaler Versicherungssumme gerechnet)</div>
              }

              <button (click)="getPraemie()">Prämie neu berechnen</button>
              <br>

              </form>
            </mat-card>


          </mat-grid-tile>
          <mat-grid-tile>

            <mat-card class="myCard myDataTab">

              @if (praemieOut!=undefined && praemieOut.Tarif!=undefined) {
                <div style="margin: 10px">
                  <div>
                    <span class="DataTabA">Version</span>
                    <span>{{praemieOut.Tarifversion}}</span>
                  </div>
                  <div>
                    <span class="DataTabA">Tarif</span>
                    <span>{{praemieOut.Tarif}}</span>
                  </div>
                  <div>
                    <span class="DataTabA">Tarif-Typ</span>
                    <span>{{praemieOut.TarifTyp}}</span>
                  </div>
                  @if (praemieOut.CalcOK) {
                    <div>
                      <span class="DataTabA">Alter des Tieres bei Versicherungsbeginn</span>
                      <span>{{praemieOut.AlterText}}</span>
                    </div>
                  }
                  <!--
                  <div *ngIf ="praemieOut.CalcOK">
                    <span class="DataTabA">Selbstbehalt</span>
                    <span>{{praemie.Selbstbehalt}}</span>
                  </div>
                  -->
                  @if (tarif!=undefined && praemie.TarifID!='Rindvieh') 
                  {
                    <div>
                      <span class="DataTabA">OptionBK</span>
                      <span>{{praemie.OptionBK}}</span>
                    </div>
                  }
                  <br>
                    <mat-divider style="margin-top=10px; margin-bottom: 10px;"></mat-divider>
                    <br>
                      @for (pos of  positionen; track pos) {
                        <div>
                          <span class="DataTabA">{{pos.MarketingName}}</span>
                          <span class="DataTabC" >{{globserv.formatMoney(pos.Netto)}}</span>
                        </div>
                      }
                      @if (praemieOut.RabattKombi!=undefined && praemieOut.RabattKombi>0) {
                        <div>
                          <span class="DataTabA">Rabatt Kombi:</span>
                          <span class="DataTabC" >{{globserv.formatMoney(0-praemieOut.RabattKombi)}}</span>
                        </div>
                      }
                      @if (praemieOut.CalcOK) {
                        <div>
                          <span class="DataTabA">Prämie Total:</span>
                          <span class="DataTabC" >{{globserv.formatMoney(praemieOut.PraemieTotal)}}</span>
                        </div>
                      }
                      @if (praemieOut.FlottenRabatt!=undefined && praemieOut.FlottenRabatt>0) {
                        <div style="margin-top: 10px">
                          <span class="DataTabA">Prämien inkl. FlottenRabatt von:</span>
                          <span class="DataTabC" >{{globserv.formatMoney(praemieOut.FlottenRabatt)}}</span>
                        </div>
                      }
                      <br>
                        @for (info of  praemieOut.Infos; track info) {
                          <div  >
                            {{info}} <br>
                          </div>
                        }
                      </div>
                    }
                  </mat-card>
                </mat-grid-tile>
              </mat-grid-list>
